/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        //Initiat WOW JS
        new WOW().init();

        // Create browser compatible event handler.
        var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
        var eventer = window[eventMethod];
        var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
        // Listen for a message from the iframe.
        eventer(messageEvent, function(e) {
          
          if (isNaN(e.data)) { return; }

          // replace #sizetracker with what ever what ever iframe id you need
          // if( jQe) jQuery('iframe.pardotform')[0].style.height = e.data + 'px';

        }, false);

        $('.contact-page #postcode_lookup').getAddress({
            api_key: 'r6P0-yaTw-OwdQ-xwO0',
            block_no_organisation: 'true',
            output_fields: {
                block: '#pcs_address',
                organisation: '#pcs_company'
            }
        });

        $('.contact-page #searchbox').attr('placeholder', 'Enter your postcode');
        $('.contact-page #searchbox').attr('name', 'pcs_postcode');
        $('.contact-page #searchbox').attr('required', true);
        $('.contact-page #searchbox').addClass("form-control");


        $('.contact-page #contact_form').validate({
          errorClass : 'has-error', 
          rules: {
            'pcs_fisrtname' : 'required',
            'pcs_lastname' : 'required',
            'pcs_message' : 'required',
            'pcs_postcode' : 'required',
            'pcs_address' : 'required',
            'pcs_phone' : 'required',
            'pcs_howhear' : 'required',
            'pcs_email': {
              required: true,
              email: true
            },
            'pcs_terms' : 'required'
          },
          messages: {
            'pcs_fisrtname': 'Please enter your first name',
            'pcs_lastname': 'Please enter your last name',
            'pcs_message': 'Please enter your message',
            'pcs_postcode': 'Please enter your postcode',
            'pcs_address': 'Please enter your address',
            'pcs_phone': 'Please enter your phone number',
            'pcs_howhear': 'Please specify how did you hear about us',
            'pcs_terms': 'Please tick the checbox to accept the terms and conditions!',
            'pcs_email': {
              required: 'Please enter your email',
              email: 'Please enter valid email address'
            }
          },
          errorPlacement: function(error, element) {
                error.appendTo(element.closest('.form-group'));
          },
          highlight: function(element, errorClass, validClass) {
              $(element).closest('.form-group').addClass(errorClass).removeClass(validClass);
          },
          unhighlight: function(element, errorClass, validClass) {
              $(element).closest('.form-group').removeClass(errorClass).addClass(validClass);
          },
          submitHandler: function(form) {

            var form_data   = $(form).serializeArray();
            var submit_btn  = $(form).find('.contact-form-submit');

            submit_btn.attr('disabled', true);

            $.post(
                ajaxurl,
                {
                    action: "send_contact_form",
                    formdata: form_data,
                },
                function(data) {
                    data = JSON.parse( data );
                    if( data.success == true ) {
                      // $(form)[0].reset();
                      // $('#contactmsg .contact-form-msg').text('Your message has been successfully sent. You will be contacted shortly.');
                      window.location.replace( $(form).attr('data-success') );
                    } else {

                      $('#contactmsg .contact-form-msg').text('Failed sending the form data. ERR:'+ data.response );
                      $('#contactmsg').modal('show');
                    }
                    
                    // submit_btn.attr('disabled', false);
                }
            );

            return false;

          }
        });
        //smoothScroll
        // smoothScroll.init();

        // Navigation Scroll
        // $(window).scroll(function(event) {
        //   Scroll();
        // });

        // $('.navbar-collapse ul li a').on('click', function() {  
        //   $('html, body').animate({scrollTop: $(this.hash).offset().top - 5}, 1000);
        //   return false;
        // });

        // // User define function
        // function Scroll() {
        //   var contentTop      =   [];
        //   var contentBottom   =   [];
        //   var winTop      =   $(window).scrollTop();
        //   var rangeTop    =   200;
        //   var rangeBottom =   500;
        //   $('.navbar-collapse').find('.scroll a').each(function(){
        //     contentTop.push( $( $(this).attr('href') ).offset().top);
        //     contentBottom.push( $( $(this).attr('href') ).offset().top + $( $(this).attr('href') ).height() );
        //   });
        //   $.each( contentTop, function(i){
        //     if ( winTop > contentTop[i] - rangeTop ){
        //       $('.navbar-collapse li.scroll')
        //       .removeClass('active')
        //       .eq(i).addClass('active');      
        //     }
        //   });
        // }

        // $('#tohash').on('click', function(){
        //   $('html, body').animate({scrollTop: $(this.hash).offset().top - 5}, 1000);
        //   return false;
        // });

        // // accordian
        // $('.accordion-toggle').on('click', function(){
        //   $(this).closest('.panel-group').children().each(function(){
        //   $(this).find('>.panel-heading').removeClass('active');
        //    });

        //   $(this).closest('.panel-heading').toggleClass('active');
        // });

        // Contact form
        // var form = $('#main-contact-form');
        // form.submit(function(event){
        //   event.preventDefault();
        //   var form_status = $('<div class="form_status"></div>');
        //   $.ajax({
        //     url: $(this).attr('action'),
        //     beforeSend: function(){
        //       form.prepend( form_status.html('<p><i class="fa fa-spinner fa-spin"></i> Email is sending...</p>').fadeIn() );
        //     }
        //   }).done(function(data){
        //     form_status.html('<p class="text-success">Thank you for contact us. As early as possible  we will contact you</p>').delay(3000).fadeOut();
        //   });
        // });

        //Pretty Photo
        // $("a[rel^='prettyPhoto']").prettyPhoto({
        //   social_tools: false
        // });

        // portfolio filter
        // $(window).load(function(){'use strict';
        //   var $portfolio_selectors = $('.portfolio-filter >li>a');
        //   var $portfolio = $('.portfolio-items');
        //   $portfolio.isotope({
        //     itemSelector : '.portfolio-item',
        //     layoutMode : 'fitRows'
        //   });
          
        //   $portfolio_selectors.on('click', function(){
        //     $portfolio_selectors.removeClass('active');
        //     $(this).addClass('active');
        //     var selector = $(this).attr('data-filter');
        //     $portfolio.isotope({ filter: selector });
        //     return false;
        //   });
        // });

        //   //Animated Progress
        //   $('.progress-bar').bind('inview', function(event, visible, visiblePartX, visiblePartY) {
        //     if (visible) {
        //       $(this).css('width', $(this).data('width') + '%');
        //       $(this).unbind('inview');
        //     }
        //   });

        //   //Animated Number
        //   $.fn.animateNumbers = function(stop, commas, duration, ease) {
        //     return this.each(function() {
        //       var $this = $(this);
        //       var start = parseInt($this.text().replace(/,/g, ""));
        //       commas = (commas === undefined) ? true : commas;
        //       $({value: start}).animate({value: stop}, {
        //         duration: duration == undefined ? 1000 : duration,
        //         easing: ease == undefined ? "swing" : ease,
        //         step: function() {
        //           $this.text(Math.floor(this.value));
        //           if (commas) { $this.text($this.text().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")); }
        //         },
        //         complete: function() {
        //           if (parseInt($this.text()) !== stop) {
        //             $this.text(stop);
        //             if (commas) { $this.text($this.text().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")); }
        //           }
        //         }
        //       });
        //     });
        //   };

        //   $('.animated-number').bind('inview', function(event, visible, visiblePartX, visiblePartY) {
        //     var $this = $(this);
        //     if (visible) {
        //       $this.animateNumbers($this.data('digit'), false, $this.data('duration')); 
        //       $this.unbind('inview');
        //     }
        //   });


        $('.home-services .service-box').matchHeight({ byRow:false });
        
        $('.reseller-page .reseller-page-box').matchHeight({ byRow:false });

        var time = 7; // time in seconds

        var $progressBar,
            $bar, 
            $elem, 
            isPause, 
            tick,
            percentTime;
       
          //Init the carousel
          $(".home-slider").find('.owl-carousel').owlCarousel({
            slideSpeed : 500,
            paginationSpeed : 500,
            singleItem : true,
            navigation : true,
            pagination: false,
            navigationText: [
            "<i class='fa fa-angle-left'></i>",
            "<i class='fa fa-angle-right'></i>"
            ],
            afterInit : progressBar,
            afterMove : moved,
            startDragging : pauseOnDragging,
            //autoHeight : true,
            transitionStyle : "fadeUp"
          });
       
          //Init progressBar where elem is $("#owl-demo")
          function progressBar(elem){
            $elem = elem;
            //build progress bar elements
            buildProgressBar();
            //start counting
            start();
          }
       
          //create div#progressBar and div#bar then append to $(".owl-carousel")
          function buildProgressBar(){
            $progressBar = $("<div>",{
              id:"progressBar"
            });
            $bar = $("<div>",{
              id:"bar"
            });
            $progressBar.append($bar).appendTo($elem);
          }
       
          function start() {
            //reset timer
            percentTime = 0;
            isPause = false;
            //run interval every 0.01 second
            tick = setInterval(interval, 10);
          }
       
          function interval() {
            if(isPause === false){
              percentTime += 1 / time;
              $bar.css({
                 width: percentTime+"%"
               });
              //if percentTime is equal or greater than 100
              if(percentTime >= 100){
                //slide to next item 
                $elem.trigger('owl.next');
              }
            }
          }
       
          //pause while dragging 
          function pauseOnDragging(){
            isPause = true;
          }
       
          //moved callback
          function moved(){
            //clear interval
            clearTimeout(tick);
            //start again
            start();
          }

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
